import { TreeNode } from "@/types/tree";

export type SectionCategory = string;

export type SingularitySectionLibrary = {
  [key: SectionCategory]: TreeNode[];
};

let singularitySectionLibrary: SingularitySectionLibrary = {};

export function setSingularitySectionLibrary(library: SingularitySectionLibrary) {
  console.log('do this once at the beginning and cache it, the thing that calls this might have a performance penalty because it might be fetching it remotely.');
  console.log("Setting singularity section library", library);
  singularitySectionLibrary = library;
}

export function getSingularitySectionLibrary() {
  return singularitySectionLibrary;
}
